// extracted by mini-css-extract-plugin
export var menuItem = "F_tW d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "F_tX d_W d_bw d_bL";
export var menuMainLink = "F_tY d_fX d_dx";
export var menuLink = "F_tZ d_fX d_dx";
export var Link = "F_r3 v_r3 v_rn v_rJ";